export const HYGIENE_SERVICE = "Cuidar da higiene pessoal das crianças";

export const BABYSITTER_BASIC_SERVICES = [
  "Cuidar da higiene pessoal das crianças",
  "Supervisão e segurança contínua",
  "Rotina de alimentação da criança",
  "Apoio em descanso e soneca",
];

export const BABYSITTER_EXTRA_SERVICES = [
  "Preparar refeições para crianças",
  "Organizar e limpar o quarto das crianças",
  "Administrar medicamentos (com orientação)",
  "Acompanhamento em atividades escolares",
  "Passeios e atividades ao ar livre",
  "Cozinhar para crianças",
  "Lavar e passar roupas das crianças",
  "Ajuda com dever de casa",
  "Limpeza leve (brinquedos)",
];

export function sanitizeExtraServices(services) {
  if (!Array.isArray(services)) return [];

  const unique = [...new Set(services)];
  return unique.filter(
    (service) => service !== HYGIENE_SERVICE && BABYSITTER_EXTRA_SERVICES.includes(service),
  );
}
